import myCorrespondence from "./myCorrespondence";

export default myCorrespondence;
